import { lightTheme } from '@/customTheme'
import HeadingInspector from '@/components/HeadingInspector'
import { CSSProperties } from 'react'

function ModalHeader(props: {
  hasBoxShadow?: boolean
  hasNavigation: boolean
  handleNavigation?: () => void
  title: string
  hasClose?: boolean
  handleClose?: () => void
  style?: CSSProperties
  hasQuestionMarkButton?: boolean
  questionMarkButtonAction?: () => void
  showDiscardModalOnChanges?: boolean
  discardModalHeader?: string
  discardModalDescription?: string
  areChangesToDiscard?: boolean
  disableNavigation?: boolean
  titleStyle?: CSSProperties
}) {
  const { titleStyle, ...restProps } = props

  return (
    <HeadingInspector
      {...restProps}
      titleStyle={{ ...lightTheme.typography.Header26bold, textAlign: 'center', ...titleStyle }}
    />
  )
}

export default ModalHeader
